// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumb":"Breadcrumbs_Breadcrumb__Of-Lf","Item":"Breadcrumbs_Item__2M1aU","Link":"Breadcrumbs_Link__3QC_F","Current":"Breadcrumbs_Current__kGDpq"};